// extracted by mini-css-extract-plugin
module.exports = {"classh4":"NewsRound_classh4__XLCqj"};